<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>代理管理</el-breadcrumb-item>
        <el-breadcrumb-item>代理人列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addAgentBtn" :loading="state">新增代理人</el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="addAgentForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="代理人邮箱 " prop="cardPassword">
          <el-input v-model="queryInfo.agentEmail"  clearable placeholder="支持模糊查询" @input="changeInput($event)"></el-input>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>
      <div>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">1.让代理注册代理端，并且登录代理端，代理端右上角复制唯一标识码</el-tag>
      </div>
      <div>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">2.作者新增代理，填入刚才的唯一标识码</el-tag>
      </div>
      <div>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">3.作者开放卡类代理，软件管理，更多，配置卡类，修改，开放代理</el-tag>
      </div>
      <div>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">4.添加代理可以使用的卡类，代理人列表，编辑卡类</el-tag>
      </div>
      <div>
        <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">5.给代理积分，代理人列表，加减积分</el-tag>
      </div>
      <el-table :data="tableList" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="softName" label="软件" width="200"></el-table-column>
        <el-table-column prop="code" label="代理人标识码" width="310"></el-table-column>
        <el-table-column prop="agentEmail" label="代理人邮箱" width="240"></el-table-column>
        <el-table-column prop="level" label="代理人等级" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.level}}级代理</span>
          </template>
        </el-table-column>
        <el-table-column prop="integral" label="积分余额" width="120"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="新增时间" width="170"></el-table-column>
        <el-table-column prop="operator" label="操作人" width="240"></el-table-column>
        <el-table-column label="操作" width="425">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="integral(scope.row)">加减积分</el-button>
            <el-button @click="handleClick(scope.row)" size="mini" type="primary">权 限</el-button>
            <el-button @click="unbinding(scope.row)" size="mini" type="danger">解 绑</el-button>
            <el-button type="primary" size="mini" @click="cardTypeRelation(scope.row)">编辑卡类</el-button>
            <el-button type="primary" size="mini" @click="changeRemarks(scope.row)">修改备注</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新增代理 -->
    <el-dialog title="新增代理人" :close-on-click-modal="false" :visible.sync="addDialogVisible" :width="addAgentWidth" @close="closeAddDiaLog">
      
      <el-form :model="addAgentForm" :rules="addAgentrules" ref="addAgentFormRef" label-width="110px" class="demo-ruleForm" size="small">
        <el-form-item label="代理软件" prop="softName">
          <el-select v-model="addAgentForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="代理人标识码" prop="code" >
            <el-input v-model="addAgentForm.code" clearable placeholder="请输入36位标识码"></el-input>
        </el-form-item>

        <el-form-item label="分配积分" prop="integral" >
          <el-input-number :precision="0" v-model="addAgentForm.integral" controls-position="right" :min="0" :max="1000000" @input="changeInput($event)"></el-input-number>
        </el-form-item>

        <el-form-item label="代理人备注" prop="remarks" >
            <el-input type="textarea" v-model="addAgentForm.remarks" placeholder="长度不超过128个字符" @input="changeInput($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createAgent" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 修改备注 -->
    <el-dialog :title="changeRemarksForm.agentEmail" :close-on-click-modal="false" :visible.sync="changeRemarksDialogVisible" :width="changeRemarksWidth">
      <el-form :model="changeRemarksForm" :rules="changeRemarksFormrules" ref="changeRemarksFormRef" label-width="100px" class="demo-ruleForm" size="small">
        <el-form-item label="代理人备注" prop="remarks" >
            <el-input type="textarea" v-model="changeRemarksForm.remarks" placeholder="长度不超过128个字符" @input="changeInput($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="changeRemarksBtn" :loading="state">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 加减积分Dialog -->
    <el-dialog title="加减积分" :close-on-click-modal="false" :visible.sync="integralDialogVisible" :width="addSubWidth" >
      <el-form :model="integralForm" :rules="integralFormrules" ref="integralFormRef" label-width="100px" class="demo-ruleForm" size="small">
        <el-form-item label="动作 " prop="action" >
          <el-select v-model="integralForm.action" @change="changeInput()">
            <el-option label="购买( + )" value="购买"></el-option>
            <el-option label="回收( - )" value="回收"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="积分" prop="integral" >
          <el-input-number :precision="0" v-model="integralForm.integral" controls-position="right" :min="0" :max="1000000" @input="changeInput($event)"></el-input-number>
        </el-form-item>

        <el-form-item label="代理人备注" prop="remarks" >
            <el-input type="textarea" v-model="integralForm.remarks" placeholder="长度不超过128个字符" @input="changeInput($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="integralBtn" :loading="state">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 代理权限dialog -->
    <el-dialog title="代理权限" :close-on-click-modal="false" :visible.sync="rightDialogVisible" :width="agentRightWidth">
      <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">开放自定义多开上限,每张卡消耗积分=单张卡积分*多开数量</el-tag>
      
      <div class="custom">
        <label for="customid" class="islabel">可自定义多开上限</label>
        <el-switch id="customid" style="display: block" v-model="customUpperLimit" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <div class="children">
        <label for="childrenid" class="islabel">可开设子代理</label>
        <el-switch id="childrenid" style="display: block" v-model="openChildren" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <div class="delcard">
        <label for="delcardid" class="islabel">允许子代理删卡</label>
        <el-switch id="delcardid" style="display: block" v-model="delCard" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <div class="unbind">
        <label for="unbindid" class="islabel">允许代理解绑</label>
        <el-switch id="unbindid" style="display: block" v-model="unbindPurview" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <div class="unbind">
        <label for="multiTransformAddId" class="islabel">允许多开转换增加</label>
        <el-switch id="multiTransformAddId" style="display: block" v-model="multiTransformAdd" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <div class="unbind">
        <label for="multiTransformSubId" class="islabel">允许多开转换减少</label>
        <el-switch id="multiTransformSubId" style="display: block" v-model="multiTransformSub" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="rightBtn" :loading="state">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 解绑dialog -->
    <el-dialog title="确定要解绑此代理人？" :close-on-click-modal="false" :visible.sync="unbindingDialog" :width="agentRightWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定 {{integralInfo.softName}} 要解绑此代理人？<br></span>
      </div>

      <span style="margin-left:30px">{{integralInfo.agentEmail}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unbindingDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="unbindingDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑卡类 添加代理卡类dialog -->
    <el-dialog title="添加代理使用的卡类" :close-on-click-modal="false" :visible.sync="cardTypeRelationDialogVisible" :width="addAgentCardTypeWidth">
      <el-button type="primary" icon="el-icon-plus" size="small" :loading="state" @click="addCardType" style="margin-bottom:10px">添加卡类</el-button>
      
      <el-table :data="cardTypetableList" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="cardName" label="卡类名称" width="140"></el-table-column>
        <el-table-column prop="agentPrice" label="代理价格" width="90"></el-table-column>
        <el-table-column prop="value" label="值" width="50"></el-table-column>
        <el-table-column prop="company" label="单位" width="70"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="添加时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="editCardTypeRelation(scope.row)" size="mini" type="primary">编 辑</el-button>
            <el-button @click="delCardTypeRelation(scope.row)" size="mini" type="danger">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChangeChild"
        @current-change="handleCurrentChangeChild"
        :current-page="queryInfoChild.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfoChild.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="agentCardTypeTotal"
      >
      </el-pagination>
      
    </el-dialog>

    <!-- 添加代理允许使用的卡类 -->
    <el-dialog title="添加卡类" :close-on-click-modal="false" :visible.sync="addcardTypeDialogVisible" :width="addUserDialogWidth" @close="closeChildldDiaLog">
      <el-form ref="addCardTypeFromRef" :model="addCardTypeFrom" label-width="80px" :rules="addCardTypeFromRules" class="edit-form" size="small">
        <el-form-item label="卡类" prop="cardTypeId">
          <el-select v-model="addCardTypeFrom.cardTypeId" placeholder="请选择卡类" >
            <el-option v-for="item in cardType" :key="item._id" :label="item.cardName" :value="item._id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理价格" prop="agentPrice">
          <el-input-number :precision="0" v-model="addCardTypeFrom.agentPrice" controls-position="right" :min="1" :max="1000" @input="changeInput($event)"></el-input-number>
        </el-form-item>
        <el-form-item label="备注 " prop="remarks">
          <el-input type="textarea" v-model="addCardTypeFrom.remarks" placeholder="长度不超过128个字符" @input="changeInput($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addcardTypeDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" :loading="state" @click="addAgentCardType">添 加</el-button>
      </span>
    </el-dialog>

    <!-- 编辑代理允许使用的卡类 -->
    <el-dialog title="编辑卡类" :close-on-click-modal="false" :visible.sync="editcardTypeDialogVisible" :width="addUserDialogWidth" @close="closeEditCardTypeRelationDiaLog">
      <el-form ref="editCardTypeFromRef" :model="editCardTypeFrom" label-width="80px" :rules="editCardTypeFromRules" class="edit-form" size="small">
        <el-form-item label="卡类" prop="cardTypeId">
          <!-- <el-select v-model="editCardTypeFrom.cardTypeId" placeholder="请选择卡类">
            <el-option v-for="item in cardType" :key="item._id" :label="item.cardName" :value="item._id"></el-option>
          </el-select> -->
          <el-input v-model="editCardTypeFrom.cardName" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="代理价格" prop="agentPrice">
          <el-input-number :precision="0" v-model="editCardTypeFrom.agentPrice" controls-position="right" :min="1" :max="1000" @input="changeInput($event)"></el-input-number>
        </el-form-item>
        <el-form-item label="备注 " prop="remarks">
          <el-input type="textarea" v-model="editCardTypeFrom.remarks" placeholder="长度不超过128个字符" @input="changeInput($event)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editcardTypeDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" :loading="state" @click="editAgentCardType">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      changeRemarksForm:{},
      changeRemarksWidth:'500px',
      changeRemarksDialogVisible:false,
      changeRemarksFormrules:{
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ],
      },
      addDialogVisible: false,
      addAgentForm:{
        softName: '',
        code: '',      // 明确初始化属性
        integral: 0,
        remarks: ''
      },
      addAgentrules:{
        softName:[
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        code:[
          { required: true, message: "请输入代理人唯一标识码!", trigger: ["blur", "change"] },
          { len: 36,message: "代理人标识符为36位!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ],
      },
      state:false,
      allSoftName:"",

      tableList:[],
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      queryInfoChild:{
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
      },
      total:0,
      integralDialogVisible:false,

      integralForm:{
        action:"购买",
        integral:0
      },
      integralFormrules:{
        action:[
          { required: true, message: "请选择!", trigger: ["blur", "change"] }
        ],
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ],
      },
      integralInfo:"",
      rightDialogVisible:false,
      customUpperLimit: false,
      openChildren: false,
      delCard: false,
      unbindPurview:false,
      multiTransformAdd:false,
      multiTransformSub:false,

      unbindingDialog:false,
      loading:true,
      addAgentWidth:'500px',
      addSubWidth:'500px',
      agentRightWidth:'500px',

      agentEmail:"",
      authEmail:"",
      appKey:"",
      cardTypeRelationDialogVisible:false,
      addcardTypeDialogVisible:false,
      addCardTypeFrom:{
        cardTypeId:"",
        agentPrice: 1
      },
      addCardTypeFromRules:{
        agentPrice:[
          // { min: 1,max: 1000,message: "代理价格最大为1000!",trigger: ["blur", "change"]},
        ],
        cardTypeId:[
          { required: true, message: "请选择卡类", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ]
      },
      addUserDialogWidth: '500px',
      addAgentCardTypeWidth:'800px',
      cardType:[],
      cardTypetableList:[],
      agentCardTypeTotal:0,

      editcardTypeDialogVisible:false,
      editCardTypeFrom:{},
      editCardTypeFromRules:{
        agentPrice:[
          // { min: 1,max: 1000,message: "代理价格最大为1000!",trigger: ["blur", "change"]},
        ],
        cardTypeId:[
          { required: true, message: "请选择卡类", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ]
      },
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getAgentList()
    if (this.isMobile()){
      this.addAgentWidth = '100%'
      this.addSubWidth = '100%'
      this.agentRightWidth = '100%'
      this.addUserDialogWidth = '100%'
      this.addAgentCardTypeWidth = '100%'
    }
  },
  methods:{
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // localStorage.setItem('isiphone',flag)
      //console.log(flag)
      return flag;
    },
    //得到代理人列表
    async getAgentList(){
      //const result = await this.$http.get(`getAgentList?email=${this.$store.state.account}`);
      console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("getAgentList",{
        params:this.queryInfo
      });
      this.state = false
      console.log(result);
      this.tableList = result.data.data.data
      this.total = result.data.data.total
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
    },
    addAgentBtn(){
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addAgentFormRef.clearValidate();
      });
    },
    refresh(){

    },
    closeAddDiaLog(){
      console.log('关闭了');
      this.$refs.addAgentFormRef.resetFields()
      // this.addAgentForm = {}
    },
    //创建代理人的按钮
    async createAgent(){
      this.$refs.addAgentFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.addAgentForm.email = this.$store.state.account
        const result = await this.$http.post("createAgent", this.addAgentForm);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.addDialogVisible = false
        this.$refs.addAgentFormRef.resetFields()
        this.getAgentList()
      })
    },
    refresh(){
      this.getCardTypeSoftName()
      this.getAgentList()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getAgentList()
    },
    reSet(){
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.$refs.agentRef.resetFields()
      this.getAgentList()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getAgentList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getAgentList()
    },

    handleSizeChangeChild(val){
      this.queryInfoChild.pagesize = val
      this.getCardTypeRelation()
    },
    handleCurrentChangeChild(val){
      this.queryInfoChild.pagenum = val
      this.getCardTypeRelation()
    },
    
    //加减积分
    integral(index){
      // console.log("index:",index);
      this.integralDialogVisible = true
      this.integralInfo = index
      // this.integralForm.remarks = index.remarks
    },
    integralBtn(){
      this.$refs.integralFormRef.validate(async valid => {
        console.log(valid);
        // console.log("integralInfo:",this.integralInfo);
        if(!valid) return
        this.state = true
        this.integralInfo.email = this.$store.state.account
        this.integralInfo.action = this.integralForm.action
        this.integralInfo.integral = this.integralForm.integral
        if(this.integralForm.remarks){
          this.integralInfo.remarks = this.integralForm.remarks
        }
        const result = await this.$http.post("addsubintegral", this.integralInfo);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.integralDialogVisible = false
        this.$refs.integralFormRef.resetFields()
        this.getAgentList()
      })
    },
    //获取卡类关系
    async getCardTypeRelation(){
      this.state = true
      const result = await this.$http.post('getcardtyperelation',{
        appKey: this.appKey, 
        agentEmail: this.agentEmail,
        pagenum: this.queryInfoChild.pagenum,
        pagesize: this.queryInfoChild.pagesize,
      })
      console.log("result:",result);
      this.cardTypetableList = result.data.data.agentCardType
      this.agentCardTypeTotal = result.data.data.total
      this.state = false
    },
    //编辑卡类关系
    async cardTypeRelation(value){
      console.log("编辑卡类关系:",value);
      this.agentEmail = value.agentEmail
      this.authEmail = value.authEmail
      this.appKey = value.appKey
      this.state = true
      const result = await this.$http.post('getcardtyperelation',{
        appKey:this.appKey, 
        agentEmail: this.agentEmail,
        pagenum: 1,
        pagesize: 10,
      })
      console.log("共计：",result.data.data.total);
      console.log("result:",result.data.data.agentCardType);
      this.cardTypetableList = result.data.data.agentCardType
      this.agentCardTypeTotal = result.data.data.total
      this.state = false
      this.cardTypeRelationDialogVisible = true
    },
    //修改备注
    async changeRemarks(value){
      this.changeRemarksForm = value
      this.changeRemarksDialogVisible = true
    },
    //更改备注
    async changeRemarksBtn(){
      this.$refs.changeRemarksFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        // console.log("this.changeRemarksForm:",this.changeRemarksForm);
        const result = await this.$http.post("updateagentremarks", this.changeRemarksForm);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.changeRemarksDialogVisible = false
        this.$refs.changeRemarksFormRef.resetFields()
        this.getAgentList()
      })
    },
    //编辑卡类
    async editCardTypeRelation(value){
      console.log("点击编辑value=", value);
      /*
      this.state = true
      const result = await this.$http.post('allowcardType',{})
      this.state = false
      console.log("卡类：",result);
      console.log(result.data.meta.status);
      if (result.data.meta.status == 200) {
        this.cardType = result.data.data.map(element =>{
          console.log(element._id+"----"+element.cardName);
          return {
            cardName: element.cardName, 
            _id: element._id}
        })
        // console.log("this.cardType:",this.cardType);
      }
      // console.log("value:",value);
      */
      // this.editCardTypeFrom._id = value._id
      // this.editCardTypeFrom.agentPrice = value.agentPrice
      // this.editCardTypeFrom.remarks = value.remarks
      // this.editCardTypeFrom.cardName = value.cardName
      // this.editCardTypeFrom = JSON.stringify(value);
      // this.editCardTypeFrom = JSON.parse(this.editCardTypeFrom)
      this.editCardTypeFrom = value;
      //this.editCardTypeFrom.agentPrice = value.agentPrice
      console.log("this.editCardTypeFrom.agentPrice:",this.editCardTypeFrom.agentPrice);
      //this.editCardTypeFrom.type = value.cardName
      console.log("this.editCardTypeFrom._id:",this.editCardTypeFrom._id);
      this.editcardTypeDialogVisible = true
    },
    //保存编辑的卡类
    async editAgentCardType(){
      this.state = true
      console.log("this.editCardTypeFrom:",this.editCardTypeFrom);
      this.editCardTypeFrom.agentPrice = parseInt(this.editCardTypeFrom.agentPrice)
      const result = await this.$http.post('updatecardrelation',this.editCardTypeFrom)
      this.state = false
      console.log("编辑保存结果：",result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.getCardTypeRelation()
      this.editcardTypeDialogVisible = false
      this.$refs.editCardTypeFromRef.resetFields()
    },

    //关闭编辑卡类事件
    closeEditCardTypeRelationDiaLog(){
      console.log("-=-=closeEditCardTypeRelationDiaLog");
      this.editCardTypeFrom = {}
      // this.$refs.editCardTypeFromRef.resetFields()
    },
    //删除卡类关系
    async delCardTypeRelation(value){
      console.log("删除value",value);
      this.state = true
      console.log();
      const result = await this.$http.post('delcardrelation',{_id:value._id})
      this.state = false
      console.log("删除结果：",result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.getCardTypeRelation()
      //this.editcardTypeDialogVisible = false
      //this.$refs.editCardTypeFromRef.resetFields()
    },
    //添加该代理可以使用的卡类
    async addCardType(){
      console.log("添加卡类被点击");
      console.log("this.agentEmail:",this.agentEmail);
      console.log("this.authEmail:",this.authEmail);
      console.log("this.appKey:",this.appKey);
      this.state = true
      const result = await this.$http.post('allowcardType',{})
      this.state = false
      console.log("卡类：",result);
      console.log(result.data.meta.status);
      if (result.data.meta.status == 200) {
        this.cardType = result.data.data.map(element =>{
          console.log(element._id+"----"+element.cardName);
          return {
            cardName: element.cardName, 
            _id: element._id}
        })
        console.log("this.cardType:",this.cardType);
      }
      this.addcardTypeDialogVisible = true
    },
    //增加代理卡类和对应的价格
    addAgentCardType(){
      this.$refs.addCardTypeFromRef.validate(async valid => {
        if(!valid) return
        // 
        this.state = true
        console.log("this.addCardTypeFrom:",this.addCardTypeFrom);
        this.addCardTypeFrom.agentEmail = this.agentEmail
        this.addCardTypeFrom.appKey = this.appKey
        this.addCardTypeFrom.agentPrice = parseInt(this.addCardTypeFrom.agentPrice)
        const result = await this.$http.post("addcardtyperelation", this.addCardTypeFrom);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.getCardTypeRelation()
        this.addcardTypeDialogVisible = false
        this.$refs.addCardTypeFromRef.resetFields()
      })
    },
    closeChildldDiaLog(){
      this.$refs.addCardTypeFromRef.resetFields()
    },
    handleClick(index){
      this.rightDialogVisible = true
      this.integralInfo = index
      console.log("this.integralInfo:",this.integralInfo);
      this.customUpperLimit = this.integralInfo.customUpperLimit
      console.log("this.customUpperLimit:",this.customUpperLimit);
      this.openChildren = this.integralInfo.openChildren
      this.delCard = this.integralInfo.delCard
      this.unbindPurview = this.integralInfo.unbindPurview
      this.multiTransformAdd = this.integralInfo.multiTransformAdd
      this.multiTransformSub = this.integralInfo.multiTransformSub
    },
    async rightBtn(){
      this.state = true
      // this.integralInfo.isUpperLimit = this.upperLimit
      // this.integralInfo.childrenAgent = this.childrenAgent
      // console.log("this.integralInfo:",this.integralInfo);
      this.integralInfo.customUpperLimit = this.customUpperLimit
      this.integralInfo.openChildren = this.openChildren
      this.integralInfo.delCard = this.delCard
      this.integralInfo.unbindPurview = this.unbindPurview
      this.integralInfo.multiTransformAdd = this.multiTransformAdd
      this.integralInfo.multiTransformSub = this.multiTransformSub
      const result = await this.$http.post("isUpperLimit", this.integralInfo);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.rightDialogVisible = false
      this.getAgentList()
    },
    unbinding(index){
      this.integralInfo = index
      this.unbindingDialog = true
    },
    async unbindingDialogBtn(){
      this.state = true
      this.integralInfo.email = this.$store.state.account
      const result = await this.$http.post("breakagent", this.integralInfo);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.unbindingDialog = false
      this.getAgentList()
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}

.children{
  margin-top: 20px;
  margin-left: 28px;
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}

.delcard{
  margin-top: 20px;
  margin-left: 15px;
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}

.unbind{
  margin-top: 20px;
  margin-left: 28px;
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}
.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>